import { useTranslation, UseTranslationResponse } from 'react-i18next';

type TransFieldType<T extends string> = T | '' | `${string}:${T}`;
type tFunctionType = <T extends string>(transField: TransFieldType<T>, options?: any) => string;

export const useMyTranslations = <T extends string>(name: string[] | string) => {
  const { t: oldT, ...rest } = useTranslation(name);
  const t = (transField: TransFieldType<T>, options?: any): string => {
    // TODO need to check with not single word transField
    // if (transField.split(' ').length > 1) {
    //   // transField must be a single word
    //   const fileNames = Array.isArray(name) ? name.join(', ') : name;
    //   throw new Error(`String '${transField}' has more than 1 words. From <${fileNames}> files`);
    // }
    if (transField.includes(':')) {
      const arr = Array.isArray(name) ? name : [name];
      if (!arr.some((item) => transField.includes(item)))
        throw new Error('Wrong translation file name');
    }
    const result = (oldT as tFunctionType)(transField, options);
    if (typeof result !== 'string') {
      console.warn(`'${transField}' returned '${result}', seems it is invalid result`);
      return '';
    }
    return result;
  };
  return { ...rest, t };
};
